import { render, staticRenderFns } from "./EmergencyDisposalCard.vue?vue&type=template&id=1efb6a9c&scoped=true"
import script from "./EmergencyDisposalCard.vue?vue&type=script&lang=js"
export * from "./EmergencyDisposalCard.vue?vue&type=script&lang=js"
import style0 from "./EmergencyDisposalCard.vue?vue&type=style&index=0&id=1efb6a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efb6a9c",
  null
  
)

export default component.exports